export default {
  pt: {
    'tratativa.campo': 'Justificativa',
    'tratativa.ajuda': 'Obrigatória para justificar. Na gestão, descreva o que aconteceu, se quiser.',
    'tratativa.obrigatoria': 'Para justificar, escreva o motivo.',
    'tratativa.justificar': 'Justificar',
    'tratativa.advertir': 'Gestão',
  },
  en: {
    'tratativa.campo': 'Justification',
    'tratativa.ajuda': 'Required to justify. For a measure, describe what happened if you want.',
    'tratativa.obrigatoria': 'To justify, write the reason.',
    'tratativa.justificar': 'Justify',
    'tratativa.advertir': 'Measure',
  },
  es: {
    'tratativa.campo': 'Justificación',
    'tratativa.ajuda': 'Obligatoria para justificar. En la gestión, describa lo ocurrido si quiere.',
    'tratativa.obrigatoria': 'Para justificar, escriba el motivo.',
    'tratativa.justificar': 'Justificar',
    'tratativa.advertir': 'Gestión',
  },
}
